import { create } from 'zustand';

/**
 * Zustand store for Improvement Actions
 * Manages post-incident improvement tasks
 */
export const useImprovementActionsStore = create((set, get) => ({
    // State
    actions: [],
    loading: false,
    error: null,

    // Actions
    setActions: (actions) => set({ actions }),

    addAction: (action) => {
        const current = get().actions;
        const newItem = {
            ...action,
            id: action.id || Date.now()
        };
        set({ actions: [...current, newItem] });
        return newItem;
    },

    updateAction: (updatedAction) => {
        const current = get().actions;
        const newActions = current.map(a => a.id === updatedAction.id ? updatedAction : a);
        set({ actions: newActions });
        return updatedAction;
    },

    deleteAction: (id) => {
        const current = get().actions;
        set({ actions: current.filter(a => a.id !== id) });
    },

    // Initialize from crisis object
    initializeFromCrisis: (crisis) => {
        if (crisis?.improvementActions) {
            set({ actions: crisis.improvementActions });
        } else {
            set({ actions: [] });
        }
    },

    clearStore: () => set({ actions: [], error: null })
}));
